import { UserRole } from "tm-shared/types";

export interface DashboardCapabilities {
    canSeeWorkData: boolean;
    canSeeManagerData: boolean;
}

export const getDashboardCapabilities = (
    role: UserRole | null,
): DashboardCapabilities => ({
    canSeeWorkData: role === UserRole.Ta,
    canSeeManagerData: role === UserRole.Sv || role === UserRole.Hos,
});
